/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDashBorderTop = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 5V3h18v2zm0 4V7h2v2zm0 4v-2h2v2zm0 4v-2h2v2zm0 4v-2h2v2zm4-8v-2h2v2zm0 8v-2h2v2zm4-12V7h2v2zm0 4v-2h2v2zm0 4v-2h2v2zm0 4v-2h2v2zm4-8v-2h2v2zm0 8v-2h2v2zm4-12V7h2v2zm0 4v-2h2v2zm0 4v-2h2v2zm0 4v-2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDashBorderTop as DashBorderTop };
